import React, { useState } from "react";
import FlashcardItem from "../flashcards/FlashcardItem";
import "./StoryKeywords.css";
import "./StoryFlashcardPractice.css";

export default function StoryFlashcardPractice({ cards, onClose }) {
  const [index, setIndex] = useState(0);
  const [isFinished, setIsFinished] = useState(false);

  const current = cards[index];

  const handleAnswer = () => {
    if (index + 1 >= cards.length) {
      setIsFinished(true);
      onClose && onClose();
    } else {
      setIndex((i) => i + 1);
    }
  };

  if (isFinished) {
    return (
      <div className="story-practice-finished-container">
        <h2 className="story-practice-finished-title">🥳 Prática concluída!</h2>
        <p className="story-practice-finished-subtitle">
          Você revisou todas as palavras desta história.
        </p>
  
        <button
          className="story-practice-finished-button"
          onClick={() => {
            setIndex(0);
            setIsFinished(false);
          }}
        >
          Praticar novamente
        </button>
      </div>
    );
  }
  

  if (!current) return null;

  return (
    <div className="story-practice-wrapper">
        <div className="story-practice-progress">
            {cards.map((_, i) => (
            <div
                key={i}
                className={
                i < index
                    ? "session-bar done"
                    : i === index
                    ? "session-bar active"
                    : "session-bar"
                }
            />
            ))}
        </div>

      <div className="story-practice-container">
        <FlashcardItem
          card={current}
          onStatusChange={handleAnswer}
          trainingMode={true}   // 👈 IMPORTANT
        />
      </div>
    </div>
  );
}
